import exhibition_program_en from "./exhibition-program-en.json";
import exhibition_program_tc from "./exhibition-program-tc.json";

/**
 * Extracts the HTML content from the given JSON data.
 *
 * - The input is expected to be an array with exactly one item.
 * - Each item contains a `content` field that holds an HTML string.
 * - If the `content` field is an empty string, it indicates there is no exhibition program.
 *
 * @param jsonData - An array of JSON objects, each with a `content` field
 * @returns An array of HTML strings (usually length 1)
 */

// !!
// There is no simplified Chinese version of json prepared here
// because it will be automatically converted using a tool,
// so just keep a traditional Chinese version of json.
// !!

const getSubPageHTML = (jsonData: any[]): string[] => {
  return jsonData?.map((item) => item?.content);
};

export const subPageHTML_en = getSubPageHTML(exhibition_program_en)?.[0] ?? "";

export const subPageHTML_tc = getSubPageHTML(exhibition_program_tc)?.[0] ?? "";
